var _style, _defs, _g, _path, _path2, _g2, _path3, _path4, _circle, _circle2, _path5, _circle3, _circle4, _path6, _g3, _circle5, _circle6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrameSp012(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "design",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 375 366.8",
    style: {
      enableBackground: "new 0 0 375 366.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000021805790548927565250000017658875817850126996_);}\r\n\t.st1{fill:#030646;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:0.7505;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 375,
    height: 366.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070807939377512209580000013021391211715583872_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000070807939377512209580000013021391211715583872_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-77.6,41.8c33,0,33-6,66.1-6s33.1,6,66.1,6c33.1,0,33.1-6,66.1-6c33.1,0,33.1,6,66.1,6s33-6,66.1-6 s33,6,66.1,6s33-6,66.1-6s33,6,66.1,6v318.4c-33,0-33,6-66.1,6s-33-6-66.1-6s-33,6-66.1,6s-33-6-66.1-6s-33.1,6-66.1,6 s-33.1-6-66.1-6s-33.1,6-66.1,6s-33-6-66.1-6L-77.6,41.8L-77.6,41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M451.3,360.2c-33,0-33,6-66.1,6s-33-6-66.1-6s-33,6-66.1,6s-33-6-66.1-6s-33.1,6-66.1,6s-33.1-6-66.1-6 s-33.1,6-66.1,6s-33-6-66.1-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M305,354.6c3.9-0.3,8.5-0.4,13.9-0.4c26.2,0,31.6,3.8,49.2,5.3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.3,39.9c-11.1-1.8-18.8-4.1-39.6-4.1c-33.1,0-33.1,6-66.1,6s-33.1-6-66.1-6s-33.1,6-66.1,6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M213.7,39.9c11.1-1.8,18.8-4.1,39.6-4.1c33,0,33,6,66.1,6c33,0,33-6,66.1-6s33,6,66.1,6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    id: "__4_00000160895302295049174190000017906859005883578021_",
    className: "st2",
    x1: 181.5,
    y1: 31.3,
    x2: 181.5,
    y2: 50.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8734_00000156555034321789095690000012805809555508289960_",
    className: "st2",
    d: "M176.6,31v4.7c0,4-1.9,8.3-6.9,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8735_00000039099383368051378190000005212253222017373365_",
    className: "st2",
    d: "M197.4,31v4.7c0,4,1.9,8.3,6.9,8.7"
  }), /*#__PURE__*/React.createElement("line", {
    id: "__5_00000097485502504399075490000000559223950775259535_",
    className: "st2",
    x1: 192.5,
    y1: 31.3,
    x2: 192.5,
    y2: 50.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "__6_00000098919730914127590250000014737041751956637076_",
    className: "st2",
    x1: 187,
    y1: 31.7,
    x2: 187,
    y2: 48.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8736_00000031920841818272723550000015827413306641861547_",
    className: "st2",
    d: "M178.5,20.2l2.7-2.1l-2.7-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8737_00000059998982893736355970000003012727082728361906_",
    className: "st2",
    d: "M195.5,20.2l-2.7-2.1l2.7-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8738_00000111184325413096640000000013697320857853807272_",
    className: "st2",
    d: "M189.2,19.5l-2.2,3.4l-2.2-3.4H189.2 L189.2,19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8739_00000084528861112288359240000007393252569124036231_",
    className: "st2",
    d: "M187,31.7c1.1,0,3.5-0.2,4.5-0.8 c1.9,0.8,6.5,0.8,9-1.4c3.8,0.6,5.8-1,6.9-2.2c-1.5-2.1-2.6-3.7-2.7-9.3c-0.1-8.1-6.1-16.9-17.7-16.9S169.3,9.9,169.3,18 c-0.1,5.6-1.1,7.2-2.7,9.3c1.1,1.2,3.1,2.8,6.9,2.2c2.5,2.2,7.1,2.1,9,1.4C183.5,31.5,185.9,31.7,187,31.7L187,31.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "_\\u5186\\u5F62_49_00000116210070486021095430000016595760706859507862_",
    className: "st2",
    cx: 221.6,
    cy: 10.7,
    rx: 6.3,
    ry: 6.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "_\\u5186\\u5F62_50_00000040537246821069391720000005939296624605161859_",
    className: "st2",
    cx: 216.9,
    cy: 23.3,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "_\\u5186\\u5F62_51_00000049939723217615751450000004394936839381127832_",
    className: "st2",
    cx: 152.6,
    cy: 14,
    rx: 7.3,
    ry: 7.3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "_\\u5186\\u5F62_35_00000088135235186128635340000011236481479513667005_",
    className: "st3",
    d: "M358.3,345.2c-0.4,0-0.8,0.4-0.8,0.8 s0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8S358.7,345.2,358.3,345.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "_\\u5186\\u5F62_36_00000086677300832522008410000010844944176912941242_",
    className: "st3",
    d: "M301.1,354.4c-0.4,0-0.8,0.4-0.8,0.8 s0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8S301.6,354.4,301.1,354.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_35-2_00000170249750772148524390000002663495778275179447_",
    className: "st3",
    cx: 15.2,
    cy: 345.9,
    r: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_36-2_00000143588006915478951710000007971790423722964357_",
    className: "st3",
    cx: 72.4,
    cy: 355.2,
    r: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.6,354.6c-3.9-0.3-8.5-0.4-13.9-0.4c-26.2,0-31.6,3.8-49.2,5.3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_35-3_00000068665019232879750570000012633839510737874048_",
    className: "st3",
    cx: 15.2,
    cy: 56,
    r: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_36-3_00000155148000027503799440000017125361918656901259_",
    className: "st3",
    cx: 72.4,
    cy: 46.7,
    r: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.6,47.4c-3.9,0.3-8.5,0.4-13.9,0.4c-26.2,0-31.6-3.8-49.2-5.3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_547_00000147918708937339430440000017388279028699491720_",
    transform: "translate(1332 1997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_544-4_00000088822109573083218640000016122509866370495367_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8443-4_00000062899741211426221910000012680250955052314294_",
    className: "st3",
    d: "M-966.7-1645.9 c-2.1,0.3-2.7-0.1-2.7-0.4c0-0.3,0.6-0.7,2.7-0.4c-0.3-2.1,0.1-2.7,0.4-2.7s0.7,0.6,0.4,2.7c2.1-0.3,2.7,0.1,2.7,0.4 c0,0.3-0.6,0.7-2.7,0.4c0.3,2.1-0.1,2.7-0.4,2.7S-967-1643.9-966.7-1645.9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_547-2_00000170977461240344961990000000064923587393728957_",
    transform: "translate(1332 1997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_544-4-2_00000043425595758247370090000001308985983893065639_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8443-4-2_00000109714610284353911970000013754508830565663663_",
    className: "st3",
    d: "M-1323.8-1645.9 c2.1,0.3,2.7-0.1,2.7-0.4c0-0.3-0.6-0.7-2.7-0.4c0.3-2.1-0.1-2.7-0.4-2.7s-0.7,0.6-0.4,2.7c-2.1-0.3-2.7,0.1-2.7,0.4 c0,0.3,0.6,0.7,2.7,0.4c-0.3,2.1,0.1,2.7,0.4,2.7S-1323.5-1643.9-1323.8-1645.9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_547-3_00000047056498185686895070000011126600503609583278_",
    transform: "translate(1332 1997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_544-4-3_00000011725308487089046400000016558256244503829164_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8443-4-3_00000029029132753817702050000018248784095206191495_",
    className: "st3",
    d: "M-1323.8-1946.1 c2.1-0.3,2.7,0.1,2.7,0.4c0,0.3-0.6,0.7-2.7,0.4c0.3,2.1-0.1,2.7-0.4,2.7s-0.7-0.6-0.4-2.7c-2.1,0.3-2.7-0.1-2.7-0.4 c0-0.3,0.6-0.7,2.7-0.4c-0.3-2.1,0.1-2.7,0.4-2.7S-1323.5-1948.2-1323.8-1946.1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_547-4_00000011006462532638182590000016940451486049125541_",
    transform: "translate(1332 1997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_544-4-4_00000067238090225543828090000009303406745812112555_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8443-4-4_00000131356509821520456650000002915018998114738621_",
    className: "st3",
    d: "M-966.2-1946.1 c-2.1-0.3-2.7,0.1-2.7,0.4c0,0.3,0.6,0.7,2.7,0.4c-0.3,2.1,0.1,2.7,0.4,2.7s0.7-0.6,0.4-2.7c2.1,0.3,2.7-0.1,2.7-0.4 c0-0.3-0.6-0.7-2.7-0.4c0.3-2.1-0.1-2.7-0.4-2.7S-966.5-1948.2-966.2-1946.1"
  }))))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_35-4_00000178917332493573635380000002504391779743841431_",
    className: "st3",
    cx: 358.8,
    cy: 56,
    r: 0.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_36-4_00000098206392661859270000000012140623276688266685_",
    className: "st3",
    cx: 301.6,
    cy: 46.7,
    r: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M305.4,47.4c3.9,0.3,8.5,0.4,13.9,0.4c26.2,0,31.6-3.8,49.2-5.3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameSp012);
export default __webpack_public_path__ + "static/media/frame_sp_01_2.5cb97fd938644f6877e1749ea65cdee5.svg";
export { ForwardRef as ReactComponent };